/** @jsxImportSource @emotion/react */
import React from "react";
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

export default function ContactHeader() {
  const { t } = useLanguage();
  const theme = useTheme();
  const containerStylesHeader = css`
    display: flex;
    flex-direction: column;
    margin: ${theme.spacing["5xl"]} 0;
    padding-top: ${theme.spacing["4xl"]};
  `;

  const mainContainerStyles = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `;

  const titleStyles = css`
    font-family: ${theme.typography.heading2_semiBold.fontFamily};
    font-size: ${theme.typography.heading2_semiBold.fontSize};
    font-weight: ${theme.typography.heading2_semiBold.fontWeight};
    line-height: ${theme.typography.heading2_semiBold.lineHeight};
    letter-spacing: ${theme.typography.heading2_semiBold.letterSpacing};
    color: ${theme.colors.textMedium};
  `;

  return (
    <div css={containerStylesHeader}>
      <div css={mainContainerStyles}>
        <h2 css={titleStyles}>{t("contact_form_title")}</h2>
      </div>
    </div>
  );
}
